import { toRefs, computed } from 'vue';

//
var script = {
  name: 'ListItemSubtitle',
  props: {
    component: {
      type: String,
      default: 'div'
    },
    wrap: Boolean
  },
  setup(props) {
    const {
      wrap
    } = toRefs(props);
    const classes = computed(() => {
      return {
        'v-list-item__subtitle--wrap': wrap.value
      };
    });
    return {
      classes
    };
  }
};
export { script as default };